module.exports = __webpack_public_path__ + "img/hr-tree-05-c-trunk.e36f936b.png";